import { Box, Typography } from "@mui/material";
import useColors from "../api/hooks/useColors";

const ChipTag = ({ tagKey, tagValue }) => {
  const colors = useColors();
  return (
    <Box>
      <Box
        display="flex"
        flexDirection="row"
        flex={1}
        alignItems="center"
        sx={{
          borderRadius: "6px",
          border: `1px solid ${colors.grey_300}`,
        }}
      >
        <Typography
          variant="overline"
          sx={{
            color: colors.text_primary,
            padding: "4px",
            backgroundColor: colors.grey_200,
            borderRadius: "6px",
          }}
        >
          {tagKey}
        </Typography>
        <Typography
          variant="caption"
          sx={{
            color: colors.text_primary,
            padding: "4px",
            borderRadius: "6px",
          }}
        >
          {tagValue}
        </Typography>
      </Box>
    </Box>
  );
};

export default ChipTag;
